import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatusRES } from '@smarsh-cyber/shared/api';
import { ErrorMessages } from '@smarsh-cyber/shared/constants';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    req: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === HttpStatusCode.GatewayTimeout) {
          // Custom response for 504
          const customResponse = new HttpResponse({
            body: {
              message: ErrorMessages.TIMEOUT_ERROR,
              cyberCode: 0,
              status: StatusRES.ERROR,
              data: null,
              error: { errorDescription: ErrorMessages.TIMEOUT_ERROR }
            },
            status: 504,
            statusText: 'OK',
            url: req.url
          });
          return of(customResponse);
        }

        // !504 -> Pass the error along
        return throwError(() => error);
      })
    );
  }
}
